import { useConfig } from './use_config';

export const useUser = () => {
  return useConfig().user;
};
